import React from 'react';
import {Alert} from "antd";

export default ({message, type, style, ...props}) => {
  type = type || "info"

  let colors = {
    info: ["#0284c7", "#f0f9ff"],
    success: ["#65a30d", "#ecfccb"],
    warning: ["#eab308", "#fefce8"],
    invalid: ["#6b7280", "#f3f4f6"],
  }[type]

  style = _.assign({
    color: colors[0],
    backgroundColor: colors[1],
  }, style)

  return <div data-show="true" className="status-tag" style={style} {...props}>
    <div className="ant-alert-content">
      <div>{message}</div>
    </div>
  </div>
}



